// ─────────────────────────────────────────────────────────────────────────────
// External References Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the external references store slice.
// Covers CRUD, bulk delete, loading state, search, and filter actions.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { IPageCount } from 'src/app/shared/models/page.model';
import {
  ExternalReferenceFilters,
  ICreateExternalReferencePayload,
  IExternalReference,
  IUpdateExternalReferencePayload,
} from '../models/external-reference.models';

// ── Load external references ─────────────────────────────────────────────────

export const LoadExternalReferences = createAction(
  '[ ExternalReferences ] - LoadExternalReferences',
  props<{ page: IPageCount; key?: string; filters?: ExternalReferenceFilters; sortBy?: string; sortMode?: 'asc' | 'desc' }>(),
);
export const LoadExternalReferencesSuccess = createAction(
  '[ ExternalReferences ] - LoadExternalReferences Success ',
  props<{ response: APIResponse<IExternalReference> }>(),
);
export const LoadExternalReferencesError = createAction('[ ExternalReferences ] - LoadExternalReferences Error');

// ── Create external reference ────────────────────────────────────────────────

export const CreateExternalReference = createAction(
  '[ ExternalReference ] - CreateExternalReference',
  props<{ payload: ICreateExternalReferencePayload }>(),
);
export const CreateExternalReferenceSuccess = createAction(
  '[ ExternalReference ] - CreateExternalReference Success ',
  props<{ reference: IExternalReference }>(),
);
export const CreateExternalReferenceError = createAction('[ ExternalReference ] - CreateExternalReference Error');

// ── Update external reference ────────────────────────────────────────────────

export const UpdateExternalReference = createAction(
  '[ ExternalReference ] - UpdateExternalReference',
  props<{ id: number; payload: IUpdateExternalReferencePayload }>(),
);
export const UpdateExternalReferenceSuccess = createAction(
  '[ ExternalReference ] - UpdateExternalReference Success ',
  props<{ reference: IExternalReference }>(),
);
export const UpdateExternalReferenceError = createAction('[ ExternalReference ] - UpdateExternalReference Error');

// ── Delete external reference ────────────────────────────────────────────────

export const DeleteExternalReference = createAction('[ ExternalReference ] - DeleteExternalReference', props<{ id: number }>());
export const DeleteExternalReferenceSuccess = createAction('[ ExternalReference ] - DeleteExternalReference Success ');
export const DeleteExternalReferenceError = createAction('[ ExternalReference ] - DeleteExternalReference Error');

// ── Bulk delete external references ──────────────────────────────────────────

export const BulkDeleteExternalReferences = createAction('[ ExternalReferences ] - BulkDeleteExternalReferences', props<{ ids: number[] }>());
export const BulkDeleteExternalReferencesSuccess = createAction('[ ExternalReferences ] - BulkDeleteExternalReferences Success ');
export const BulkDeleteExternalReferencesError = createAction('[ ExternalReferences ] - BulkDeleteExternalReferences Error');

// ── Loader ───────────────────────────────────────────────────────────────────

export const SetExternalReferencesLoader = createAction('[ ExternalReferences ] - SetLoading', props<{ isLoading: boolean }>());

// ── Search ───────────────────────────────────────────────────────────────────

export const SetExternalReferenceSearch = createAction('[ ExternalReferences ] - SetSearch', props<{ keyword: string }>());

// ── Filters ──────────────────────────────────────────────────────────────────

export const SetExternalReferenceFilters = createAction('[ ExternalReferences ] - SetFilters', props<{ filters: ExternalReferenceFilters }>());
